import { useCallback } from "react";
import { Typography, Button, Box } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import theme from "lib/theme";
import useWorkOrders from "hooks/workOrders/useWorkOrders";
import WorkOrderCards from "./WorkOrderCards";

export default function WorkOrders() {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get("page[number]") || 1);
  const searchQuery = searchParams.get("search") ?? "";
  const { workOrders, meta, isLoading, errorMessage, deleteWorkOrder } = useWorkOrders();

  const handlePageChange = useCallback(
    (newPage: number) => {
      const next = new URLSearchParams(searchParams);
      next.set("page[number]", String(newPage));
      setSearchParams(next);
    },
    [searchParams, setSearchParams]
  );

  const handleSearchChange = useCallback(
    (q: string) => {
      const next = new URLSearchParams();
      next.set("page[number]", "1");
      if (q) next.set("search", q);
      setSearchParams(next);
    },
    [setSearchParams]
  );

  return (
    <div>
      <Box>
        <Breadcrumbs data={[{ label: "Home", to: "/" }, { label: "Work Orders" }]} />
      </Box>
      <Box sx={{ float: "right", [theme.breakpoints.down("sm")]: { float: "none" }, position: "relative", top: "-24px", [theme.breakpoints.down("sm")]: { position: "static", mt: 2 } }}>
        <Button component={RouterLink} variant="contained" size="large" to="/work_orders/new">
          New Work Order
        </Button>
      </Box>
      <Typography variant="h4" mt={{ xs: 3, sm: 3 }} fontWeight="bold">
        Work Orders
      </Typography>
      <WorkOrderCards
        workOrders={workOrders}
        isLoading={isLoading}
        errorMessage={errorMessage}
        deleteWorkOrder={deleteWorkOrder}
        meta={meta}
        page={page}
        onPageChange={handlePageChange}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
      />
    </div>
  );
}
